import React from 'react'
import { useBlog } from 'hooks/blog'
import { Container } from './styled'

export const CategoryList = () => {
  const { categoryList } = useBlog()

  return (
    <Container>
      <h4>Categories</h4>
      <ul>
        {categoryList?.map(category => {
          return (
            <li key={category.id}>
              <a href={`/blog/category/${category.url_key}`}>
                {category.name}
              </a>
            </li>
          )
        })}
      </ul>
    </Container>
  )
}
